import { PropertyPath } from '@/types';

export const nameof = <T>(propertyPath: PropertyPath<T>) => propertyPath as string;
